function Preloader() {
  return (
    <section>
      <div id="preloader">
        <div id="ctn-preloader" className="ctn-preloader">
          <div className="animation-preloader">
            <div className="icon">
              <img
                src="images/logo/x_global_blue.svg"
                alt=""
                className="m-auto d-block"
                width={80}
              />
            </div>
            <div className="txt-loading mt-2">
              <span data-text-preloader="X" className="letters-loading">
                X
              </span>
              <span data-text-preloader="G" className="letters-loading">
                G
              </span>
              <span data-text-preloader="L" className="letters-loading">
                L
              </span>
              <span data-text-preloader="O" className="letters-loading">
                O
              </span>
              <span data-text-preloader="B" className="letters-loading">
                B
              </span>
              <span data-text-preloader="A" className="letters-loading">
                A
              </span>
              <span data-text-preloader="L" className="letters-loading">
                L
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Preloader;
